module.exports = __webpack_public_path__ + "img/52.afbf01e7.jpg";